import useInfiniteFeedRow from '@cont/SWRInfiniteFeedRow/useInfiniteFeedRow';
import { getFeedAPI } from '@api/fetchers/free-live-classes';

const useEntireFeed = ({ goalUID, limit = 3 }) =>
  useInfiniteFeedRow({
    initialURL: getFeedAPI({ goalUID, limit }),
    swrOptions: {
      revalidateOnMount: false,
      revalidateFirstPage: false
    }
  });

export default useEntireFeed;
